import { View } from 'backbone';
import listService      from 'ListService.js';
import focusController  from 'FocusController.js';
import AddAssetView from 'common-views/AddAssetView.js';
import _Template from 'designer/layout-toolbox-pane.ejs';
import assetCollection from 'AssetCollection.js';

import MainView         from 'properties/MainView.js';
import StyleView        from 'properties/StyleView.js';
import NavigationView   from 'properties/NavigationView.js';
import BehaviorView     from 'properties/BehaviorView.js';
import AdvancedView     from 'properties/AdvancedView.js';


class ToolboxPaneView extends View {
    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #asset_new' : 'addAsset',
            'click .asset' : 'assetClicked'
        };

        return this;
    }

    addAsset(ev) {
        const view = new AddAssetView({ model: this.model} );
        view.render();
    }

    //============================================
    // mimic the focusController switchProps method
    // assets wont be stored within the ListService like the other controls
    // so that's the reason for placing this code here.
    //============================================
    assetClicked(ev) {

        focusController.clearAllSelected();

        listService.objectList.map( view => {
            if ( view.subviews ) {
                view.subviews.map( (propertyView) => {
                    propertyView.undelegateEvents();
                });
            }
        });

        var selectedId = ev.currentTarget.id;

        var selectedAsset = assetCollection.findWhere({assetId: selectedId});
        
        //var AssetModel = new AssetModel({id: selectedId});
        //AssetModel.assetId = selectedId;

        //var AssetModel = selectedAsset;

        this._subviews = Immutable.Map()
            .set( 'mainView',       new MainView(       { model: selectedAsset, el: $(constants.PROP_MAIN_ID)  } ))
            .set( 'styleView',      new StyleView(      { model: selectedAsset, el: $(constants.PROP_STYLE_ID) } ))
            .set( 'navigationView', new NavigationView( { model: selectedAsset, el: $(constants.PROP_NAV_ID)   } ))
            .set( 'behaviorView',   new BehaviorView(   { model: selectedAsset, el: $(constants.PROP_BHVR_ID)  } ))
            .set( 'advancedView',   new AdvancedView(   { model: selectedAsset, el: $(constants.PROP_ADVANCED_ID) } ));

        if (this._subviews) {
            this.delegateEvents();
            this._subviews.map( pview => {
                pview.render();
                pview.delegateEvents();
            });
            //this.broadcastName(view);
        }
    }

    render() {

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default ToolboxPaneView;
